import React, { createContext, ReactNode, useContext, useState } from 'react';

export interface ExistingIdentifiers {
  email: boolean;
  phoneNumber: boolean;
}

interface ExistingIdentifiersContextType {
  existingIdentifiers: ExistingIdentifiers;
  setExistingIdentifiers: React.Dispatch<React.SetStateAction<ExistingIdentifiers>>;
  isVerifying: boolean
  setIsVerifying: React.Dispatch<React.SetStateAction<boolean>>
}

const ExistingIdentifiersContext = createContext<ExistingIdentifiersContextType | undefined>(undefined);

interface ExistingIdentifiersProviderProps {
  children: ReactNode;
}

export const ExistingIdentifiersProvider: React.FC<ExistingIdentifiersProviderProps> = ({children}) => {
  const [existingIdentifiers, setExistingIdentifiers] = useState<ExistingIdentifiers>({
    email: false,
    phoneNumber: false
  });
  const [isVerifying, setIsVerifying] = useState<boolean>(false)
  
  return (
    <ExistingIdentifiersContext.Provider value={{
      existingIdentifiers,
      setExistingIdentifiers,
      isVerifying,
      setIsVerifying
    }}>
      {children}
    </ExistingIdentifiersContext.Provider>
  );
};

export const useExistingIdentifiers = (): ExistingIdentifiersContextType => {
  const context = useContext(ExistingIdentifiersContext);
  
  if (context === undefined) {
    throw new Error('useExistingIdentifiers must be used within an ExistingIdentifiersProvider');
  }
  
  return context;
};
